import { generateAvatar } from '@/utils/avatar'
import { updateAvatarApi } from '@/api/auth'
import { uploadFileApi } from '@/api/file'

const state = {
  userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
  isLoggedIn: false // 现在基于用户信息判断登录状态
}

const mutations = {
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
    state.isLoggedIn = !!userInfo && Object.keys(userInfo).length > 0
    if (userInfo && Object.keys(userInfo).length > 0) {
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    } else {
      localStorage.removeItem('userInfo')
    }
  },
  CLEAR_USER: (state) => {
    state.userInfo = {}
    state.isLoggedIn = false
    localStorage.removeItem('userInfo')
  }
}

const actions = {
  // 登录（现在只存储用户信息，不存储token）
  async login({ commit }, { userInfo }) {
    // 如果是新注册用户且没有头像，自动生成头像并保存到后端
    if (userInfo && !userInfo.avatar) {
      try {
        // 生成SVG头像
        const avatarSvg = generateAvatar(userInfo.email || userInfo.id || 'default')
        
        // 将SVG转换为Blob对象
        const blob = new Blob([avatarSvg], { type: 'image/svg+xml' })
        
        // 创建FormData并添加文件
        const formData = new FormData()
        formData.append('file', blob, 'avatar.svg')
        
        // 上传文件到服务器
        const uploadResponse = await uploadFileApi(formData)
        
        if (uploadResponse.code === 200 && uploadResponse.data) {
          // 获取文件URL，更新用户信息
          const avatarUrl = uploadResponse.data
          userInfo = {
            ...userInfo,
            avatar: avatarUrl
          }
          
          // 更新用户头像信息到后端
          await updateAvatarApi({ avatar: avatarUrl })
        } else {
          throw new Error('文件上传失败')
        }
      } catch (error) {
        console.error('头像上传和处理失败:', error)
        // 即使上传失败，也生成一个Data URL作为备用
        const avatarSvg = generateAvatar(userInfo.email || userInfo.id || 'default')
        const blob = new Blob([avatarSvg], { type: 'image/svg+xml' })
        const dataUrl = URL.createObjectURL(blob)
        userInfo = {
          ...userInfo,
          avatar: dataUrl
        }
      }
    }
    
    commit('SET_USER_INFO', userInfo)
    return Promise.resolve()
  },
  
  // 登出
  logout({ commit }) {
    commit('CLEAR_USER')
    return Promise.resolve()
  },
  
  // 重置token（用于请求失败时清除用户状态）
  resetToken({ commit }) {
    commit('CLEAR_USER')
    return Promise.resolve()
  },
  
  // 更新用户信息
  updateUserInfo({ commit }, userInfo) {
    commit('SET_USER_INFO', userInfo)
    return Promise.resolve()
  }
}

const getters = {
  userInfo: state => state.userInfo,
  isLoggedIn: state => state.isLoggedIn
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
